var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBannerTriploaEsquerda(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 430,
    height: 428,
    viewBox: "0 0 430 428",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1105_21959)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 210,
    height: 209,
    rx: 9.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 210,
    height: 209,
    rx: 9.5,
    stroke: "#767D8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.25 71.25H79.75C75.6079 71.25 72.25 74.6079 72.25 78.75V131.25C72.25 135.392 75.6079 138.75 79.75 138.75H132.25C136.392 138.75 139.75 135.392 139.75 131.25V78.75C139.75 74.6079 136.392 71.25 132.25 71.25Z",
    stroke: "#767D8C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.875 97.5C95.9816 97.5 98.5 94.9816 98.5 91.875C98.5 88.7684 95.9816 86.25 92.875 86.25C89.7684 86.25 87.25 88.7684 87.25 91.875C87.25 94.9816 89.7684 97.5 92.875 97.5Z",
    stroke: "#767D8C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.75 116.25L121 97.5L79.75 138.75",
    stroke: "#767D8C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 218.5,
    width: 210,
    height: 209,
    rx: 9.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 218.5,
    width: 210,
    height: 209,
    rx: 9.5,
    stroke: "#767D8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.25 289.25H79.75C75.6079 289.25 72.25 292.608 72.25 296.75V349.25C72.25 353.392 75.6079 356.75 79.75 356.75H132.25C136.392 356.75 139.75 353.392 139.75 349.25V296.75C139.75 292.608 136.392 289.25 132.25 289.25Z",
    stroke: "#767D8C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.875 315.5C95.9816 315.5 98.5 312.982 98.5 309.875C98.5 306.768 95.9816 304.25 92.875 304.25C89.7684 304.25 87.25 306.768 87.25 309.875C87.25 312.982 89.7684 315.5 92.875 315.5Z",
    stroke: "#767D8C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.75 334.25L121 315.5L79.75 356.75",
    stroke: "#767D8C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.5,
    y: 0.5,
    width: 210,
    height: 427,
    rx: 9.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.5,
    y: 0.5,
    width: 210,
    height: 427,
    rx: 9.5,
    stroke: "#767D8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.25 180.25H298.75C294.608 180.25 291.25 183.608 291.25 187.75V240.25C291.25 244.392 294.608 247.75 298.75 247.75H351.25C355.392 247.75 358.75 244.392 358.75 240.25V187.75C358.75 183.608 355.392 180.25 351.25 180.25Z",
    stroke: "#767D8C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.875 206.5C314.982 206.5 317.5 203.982 317.5 200.875C317.5 197.768 314.982 195.25 311.875 195.25C308.768 195.25 306.25 197.768 306.25 200.875C306.25 203.982 308.768 206.5 311.875 206.5Z",
    stroke: "#767D8C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.75 225.25L340 206.5L298.75 247.75",
    stroke: "#767D8C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1105_21959"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 430,
    height: 428,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerTriploaEsquerda);
export default __webpack_public_path__ + "static/media/BannerTriploaEsquerda.ac7140067bb869997ca986fd8541d571.svg";
export { ForwardRef as ReactComponent };